<script lang="ts">
	//Design system components
	import { Col, Container, Radio, Row, Text } from '@Shelly/shelly-design-system';
	//Helpers
	import { is_gen_2, real_id } from 'src/helpers/interface_helpers';
	//Stores
		import { readDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	import { update } from 'src/stores/ui/edit_lists';
	//Services
	import { format } from 'svelte-i18n';

	export let editableObject: {
		enable: boolean;
		ssid: any;
		is_open: boolean;
		pass: any;
		ipv4mode: string;
		ip: any;
		netmask: any;
		nameserver: any;
		gw: any;
		sta: number;
	};

	const channelOptions = ['sta', 'sta_1'];
	const channelOptionsI18n = [
		$format('sub_settings_title_wifi_mode_client'),
		$format('sub_settings_title_wifi_client_backup'),
	];

	const disableSecondWifi = Object.values($update.selectedDevices).every((device) => {
		//the idea here is to disable second channel if selected devices has only one Wi-Fi channel. Otherwise they wouldn't receive command
		const settings = readDeviceSettings(device.id);
		const isGen2 = is_gen_2(device);
		const hasSta1 = isGen2
			? typeof settings?.wifi?.sta1 !== 'undefined'
			: typeof settings?.wifi_sta1 !== 'undefined';
		return !hasSta1;
	});
	let selectedChannel = channelOptions[editableObject.sta || 0];

	const selectWiFi = (channel) => {
		editableObject.sta = channel;
		selectedChannel = channelOptions[channel];
	};
</script>

<Container class="mb-s" padding="0">
	<Text element="h2" class="mb-m"
		>{$format('wifi_channel_desc', {
			default:
				'Select which Wi-Fi channel will be updated. Shelly recommends to update Wi-Fi 2 for safety reasons.',
		})}</Text
	>

	{#each channelOptions as channel, index}
		<Row class="mb-s">
			<Col sm="10" md="11" lg="11">
				<Radio
					size="m"
					selected={channelOptions.indexOf(selectedChannel) === index}
					value={true}
					disabled={disableSecondWifi && index === 1}
					on:click={() => selectWiFi(index)}
					id="radio-zpn00ud">{channelOptionsI18n[index]}</Radio
				>
			</Col>
		</Row>
	{/each}
</Container>
